import { Popover } from '@gafe/common-ui';

import { IconDelete } from '@/components/icons/IconDelete';
import { IconHelp } from '@/components/icons/IconHelp';
import { IconPen } from '@/components/icons/IconPen';
import { ContactVm } from '@/types';

import { Address } from '../../types';

import styles from './Actions.module.scss';

export type ActionsProps = {
  address: Address;
  isSelected: boolean;
  editAddress?: (contact: ContactVm) => void;
  deleteAddress?: (contactId: string) => void;
};

export const Actions = (props: ActionsProps) => {
  const { address, isSelected, editAddress, deleteAddress } = props;

  return (
    <div className={styles.action_button_wrapper} data-testid="gafe-actions">
      <div
        className={styles.action_button}
        data-testid="action-button-edit"
        onClick={() => {
          if (editAddress) {
            editAddress(address.contact);
          }
        }}
      >
        <IconPen color={isSelected ? '#fff' : '#4E4E56'} />
        <span className={styles.action_button_label}>Edit</span>
      </div>
      {address.isDefault && (
        <Popover text="To delete this address you must first select a new default address.">
          <IconHelp className={styles.help_icon} color={isSelected ? '#fff' : '#808080'} />
        </Popover>
      )}
      {!address.isDefault && (
        <div
          className={styles.action_button}
          data-testid="action-button-delete"
          onClick={() => {
            if (deleteAddress && address.contact.contactId) {
              deleteAddress(address.contact.contactId);
            }
          }}
          style={{ marginLeft: 30 }}
        >
          <IconDelete color={isSelected ? '#fff' : '#4E4E56'} />
          <span className={styles.action_button_label}>Delete</span>
        </div>
      )}
    </div>
  );
};
